import {
  FormBlock,
  FormTemplate,
  IfFormData,
  SubmitButton,
  TextInput,
} from 'ui-builder';
import { Plan, usePlansService } from 'nekst-api';
import React from 'react';
import { DetailsFieldsSetsToggleWrapper } from 'feature-toggle';
import { DetailFieldsSetDropdown } from '../DetailFieldsSetDropdown';
import { SetupAreaConstrainedProjectTypeDropdown, TeamSetupAreaIdDropdown } from '../../Shared';

export interface CreatePlanFormProps {
  afterSubmitFunc?: (_data: any) => Promise<void>,
}

export function CreatePlanForm(props: CreatePlanFormProps) {
  const plansService = usePlansService();

  return (
    <FormTemplate<Plan>
      submitFormFunc={plansService.create}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={plansService.getCreateValidationSchema()}
      title="Create new workflow"
      buttons={
        <SubmitButton text="Save" key="save" />
      }
    >
      <FormBlock>
        <TeamSetupAreaIdDropdown source="setupAreaId" />
        <TextInput source="name" label="Please Enter a Name for This Workflow" />
        <SetupAreaConstrainedProjectTypeDropdown />
        <IfFormData conditionFunc={(data) => data._hasSets}>
          <DetailsFieldsSetsToggleWrapper>
            <DetailFieldsSetDropdown
              projectTypeSource="projectType"
              source="detailsFieldsSetId"
              label="Detail Box Set"
            />
          </DetailsFieldsSetsToggleWrapper>
        </IfFormData>

      </FormBlock>
    </FormTemplate>
  );
}
